
import React from 'react';
import Layout from '@/components/Layout';

const ForgotPasswordPage: React.FC = () => {
  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Reset Password</h1>
        <p className="mt-4">Enter your email to reset your password.</p>
      </div>
    </Layout>
  );
};

export default ForgotPasswordPage;
